import {MuseOn} from "./MuseOn";
import {Paragraph} from "./artwork-category-paragraph";

export class ArtworkCategory extends MuseOn {
    _id: string;
    images: any;
    videos: any;
    audios: any;
    paragraphs: Array<Paragraph>;
    // category_id: string;

    constructor (data) {
        super();

        this._id = data._id;
        this.images = data.images || [];
        this.videos = data.videos || [];
        this.audios = data.audios || [];
        // this.category_id = data.category_id;
        this.paragraphs = [];

        if (data.paragraphs && data.paragraphs.length) {
          this.paragraphs = data.paragraphs;
        }
    }

    getObj(removeNull: boolean = false) {
        const result =  {
            images: this.images,
            videos: this.videos,
            audios: this.audios,
            paragraphs: this.paragraphs.map(p => p.getObj(true))
        };

        return removeNull
            ? this.removeNull(result)
            : result
        ;
    }
}
